import axios from 'axios';
import Util from './util';

export default {
    requestId: async function(){
        try {
            const response = await getClient().get('/web/requestId')
            Util.log("axios requestId:",response);
            return response.data.data.id;
        } catch (error) {
            parseError(error);
        }
    },
    getToken: async function(webId){
        try {
            const response = await getClient().post('/web/getToken',{web_id:webId})
            Util.log("axios getToken:",response);
            return response.data.data.token;
        } catch (error) {
            parseError(error);
        }
    },
    getSetting: async function(){
        try {
            const response = await getClient().get('/web/getSetting')
            Util.log("axios getSetting:",response);
            return response.data.data;
        } catch (error) {
            parseError(error);
        }
    },    
    setSetting: async function(data){
        try {
            const response = await getClient().post('/web/setSetting',data)
            Util.log("axios setSetting:",response);
            return response.data;
        } catch (error) {
            parseError(error);
        }
    },
    updateFcm: async function(fcmId){
        try {
            const response = await getClient().post('/web/updateFcm',{fcm_id:fcmId})
            Util.log("axios updateFcm:",response);
            return response.data;
        } catch (error) {
            parseError(error);
        }
    },
    logout: async function(){
        try {
            const response = await getClient().get('/web/logout')
            Util.log("axios logout:",response);
        } catch (error) {
            parseError(error);
        }
    }
}

function getClient(timeout=10000) {
    const heasers= { 'api-key' :'WEB-ZzJiWlpGaC4xNTMxMjE4NjQ4LlNHemxPckJixMjE'}
    let token = Util.getToken() 
    if ( token !== '' ) {
        heasers.Authorization = 'Bearer '+token;
    }
    const instance = axios.create({
        baseURL: '/api/v1/',
        timeout: timeout,
        headers: heasers
      });
    return instance;
}

function parseError(error){
    console.log("errorssss",error.response);
    if (error.response.status === 401 ) {
        location.href="/logout"
    }

}